import { createFileRoute } from "@tanstack/react-router";

import { OnboardingForm } from "@/features/auth/onboarding";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/kickstarter")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Kickstarter");

  return <OnboardingForm />;
}
